document.addEventListener('DOMContentLoaded', function () {

    const boxes = document.querySelectorAll('.order-deadline-box');
    const titles = document.querySelectorAll('.deadline-title.psv2info');

    if (!boxes.length || !titles.length) return;

    // Dynamic date
    const today = new Date();
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };

    const formattedDate = today.toLocaleDateString('en-US', options);

    // Update ALL matching titles
    titles.forEach(function (title) {
        title.innerHTML = `Order By Midnight Tonight ${formattedDate}`;
    });

    // Show ALL matching boxes
    boxes.forEach(function (box) {
        box.classList.remove('hide');
    });

});